import { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useToastNavigation } from '../hooks';
import { UpgradeDialog } from '@/screens/billing/UpgradeDialog';
import '../App.css';

/**
 * RootLayout handles application-wide concerns like toast navigation
 * and root-level styling.
 */
export function RootLayout() {
    const location = useLocation();

    useToastNavigation();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        document.scrollingElement?.scrollTo?.(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [location.pathname]);

    return (
        <div className="App">
            <Outlet />
            <UpgradeDialog />
        </div>
    );
}
